import ParamSlider from "./paramslider.js";
import ParamTitle from "./paramtitle.js";
import ParamCheckBox from "./paramcheckbox.js";
import "./tabs.css"
import React from "react";

class PlayerTab extends React.Component
{

    constructor(props)
    {
        super(props);
        this.onchange = this.onchange.bind(this);

        if ("playerparams" in this.props)
        {
            if (!("backgroundtransparency" in this.props.playerparams))
                this.props.playerparams.lisibilityMode = 80;
            if (!("useconfintervalvalue" in this.props.playerparams))
                this.props.playerparams.useconfintervalvalue = true;
            if (!("playerintervalvalue" in this.props.playerparams))
                this.props.playerparams.playerintervalvalue = 20;
        }

    }

    componentDidMount()
    {}
    componentWillUnmount()
    {}

    onchange (paramnumber, value)
    {

        
        switch (paramnumber)
        {
            case 0: // affichage fond noir sur les sous titres
                this.props.playerparams.background = value;
                this.props.onchange({type:"player"});
                break;
            case 1: // affichage du time code dans l'image
                this.props.playerparams.displaytc = value;
                this.props.onchange({type:"player"});
                break;
            case 2: // Time code en ms
                this.props.playerparams.displaytcms = value;
                this.props.onchange({type:"player"});
                break;
            case 3: // Conserver les proportions
                this.props.playerparams.dontscale = value;
                this.props.onchange({type:"player"});
            case 4: // affichage positions verticales
                this.props.playerparams.displayhposition = value;
                this.props.onchange({type:"player"});
                break;
            case 5: // transparence du boxing
                this.props.playerparams.backgroundtransparency = value;
                this.props.onchange({type:"player"});
                break;
            case 6: // affichage alignements
                this.props.playerparams.displayhposition2 = value;
                this.props.onchange({type:"player"});
                break;
            case 7: // utiliser l'intervalle entre st
                this.props.playerparams.useconfintervalvalue = value;
                this.props.onchange({type:"player"});
                break;
            case 8: // valeur pour déplacements 
                this.props.playerparams.playerintervalvalue = value;
                this.props.onchange({type:"player"});
                break;
            break;
                
        }
    }

    render()
    {
        return(<>
        <div className="tabsettingsFullTab">
            <div className="tabsettingsTitleTab">
                {this.props.title}
                <br/><br/>
            </div>
            <div className="tabsettingscontentdata">
                <ParamTitle
                    text = {{cat:7, scat:0}}
                    />

                <ParamCheckBox
                    onchange = {this.onchange}
                    paramnumber = {0}
                    id = "PL01"
                    text ={{cat:7,scat:1}}
                    value = {this.props.playerparams.background}
                    />

                <ParamSlider 
                    onchange = {this.onchange}
                    paramnumber = {5}
                    id = "PL06"
                    text ={{cat:4,scat:29}}
                    value = {this.props.playerparams.backgroundtransparency}
                    defaultvalue = {80}
                    coid = {null}
                    min = {10}
                    max ={100}
                    unit = "%" />



                <ParamCheckBox
                    onchange = {this.onchange}
                    paramnumber = {4}
                    id = "PL05"
                    text ={{cat:7,scat:22}}
                    value = {this.props.playerparams.displayhposition}
                    />

                <ParamCheckBox
                    onchange = {this.onchange}
                    paramnumber = {6}
                    id = "PL07"
                    text ={{cat:7,scat:23}}
                    value = {this.props.playerparams.displayhposition2}
                    />

                <ParamTitle
                    text = {{cat:7, scat:2}}
                    />

                <ParamCheckBox
                    onchange = {this.onchange}
                    paramnumber = {1}
                    id = "PL02"
                    text ={{cat:7,scat:3}}
                    value = {this.props.playerparams.displaytc}
                    />

                <ParamCheckBox
                    onchange = {this.onchange}
                    paramnumber = {2}
                    id = "PL03"
                    text ={{cat:7,scat:4}}
                    value = {this.props.playerparams.displaytcms}
                />

                <ParamTitle
                    text = {{cat:7, scat:5}}
                    />
                    
                <ParamCheckBox
                    onchange = {this.onchange}
                    paramnumber = {3}
                    id = "PL04"
                    text ={{cat:7,scat:6}}
                    value = {this.props.playerparams.dontscale}
                />

                <ParamTitle
                    text = {{cat:7, scat:29}}
                    />
                <ParamCheckBox
                    onchange = {this.onchange}
                    paramnumber = {7}
                    id = "PL10"
                    text ={{cat:7,scat:30}}
                    value = {this.props.playerparams.useconfintervalvalue}
                />

                <ParamSlider 
                    onchange = {this.onchange}
                    paramnumber = {8}
                    id = "PL11"
                    text ={{cat:7,scat:31}}
                    value = {this.props.playerparams.playerintervalvalue}
                    defaultvalue = {20}
                    coid = {null}
                    min = {2}
                    max ={100}
                    unit = "Frames" />

        </div>

            
        </div>
        </>
        )
    }

}

export default PlayerTab